<div class="hero-banner-container">
  <div class="content">
    <swiper
      [slidesPerView]="1"
      [navigation]="true"
      [pagination]="{ clickable: true }"
      [autoplay]="{delay: 5000}"
    >
      <ng-template swiperSlide *ngFor="let teaser of teasers$ | async">
        <kion-teaser
          [title]="teaser.headline"
          [description]="teaser.content"
          [colorSchema]="teaser.colorSchema"
          [image]="teaser.mediaNew"
          [contentAlignment]="teaser.textRightAligned === 'true' ? 'right' : 'left'  "
          [link]="teaser.linkRef"
          [fontSize]="teaser.fontSize"
        ></kion-teaser>
      </ng-template>
    </swiper>
  </div>
</div>
